// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

import App from './App';
import router from './router';
import http from './api';
import store from './store'
import VueWebCam from 'vue-web-cam';
import 'babel-polyfill';

import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.min.css';
// import VCharts from 'v-charts'
// import 'v-charts/lib/style.css'
import 'jquery'
import 'signalR'
// import signaLRMy from './api/singal'
// import Print from 'vue-print-nb'
Vue.use(Element);
Vue.use(VueWebCam);//摄像头功能
// Vue.use(VCharts);
// Vue.use(Print);

Vue.config.productionTip = false;

Vue.prototype.$http = http;
// Vue.prototype.sg = signaLRMy;
//对名称进行定义,提供一个function函数   originVal  为形参
Vue.filter('dateNoT',function(originVal){
  if(originVal){
    const dt = new Date(originVal)
    //年的时间
    const y = dt.getFullYear()
    //月的时间  .padStart 不足两位自动补0  2位长度
    const m = (dt.getMonth() + 1 + '').padStart(2,'0')
    //日的时间
    const d = (dt.getDate() + '').padStart(2,'0')

    //小时
    const hh = (dt.getHours()+'').padStart(2,'0')
    //分钟
    const mm = (dt.getMinutes()+'').padStart(2,'0')
    //秒数
    const ss = (dt.getSeconds()+'').padStart(2,'0')

    //将它们拼接成完整的字符串
    //return 'yyyy-mm-dd hh:mm:ss'  可以改成下面的方法
    return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
  }else{
    return null
  }
});

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js